<template>
  <v-row align="center" justify="center">
      <v-col cols="12" align-self="center" align="center">
        <transition name="fade-slide">
          <div v-for="index in [currentIndex]" :key="index">
            <v-img
              width="980"
              height="672"
              :src="currentMap"
            >
              <template v-slot:placeholder>
                <loading-animation/>
              </template>
            </v-img>
          </div>
        </transition>
      </v-col>
      <v-col cols="12" align-self="center" align="center">
        <v-slider
          class="animation-time-map-slider"
          :prepend-icon="
            play ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline'
          "
          @click:prepend="startSlide"
          v-model="currentIndex"
          color="secondary lighten-1"
          hide-details
          min="0"
          :max="endMap"
          step="1"
        />
      </v-col>
  </v-row>
</template>

<script>
import LoadingAnimation from "../common/LoadingAnimation.vue";
export default {
  components: { LoadingAnimation },
  name: "AnimationTimeMap",
  props: {
    mapItem: {
      type: Object,
    },
  },
  data: () => ({
    play: false,
    timer: undefined,
    currentIndex: undefined,
    maps: [],
    maxHeight: undefined,
    maxWidth: undefined,

    mapRadarUrlTemplate: "/riak/pgw-radar/product{INDEX}.jpeg",
    mapRadarStartIndex: 8,
    mapRadarEndIndex: 1,

    mapPrecipitationUrlTemplate: "/riak/modelos_site/chuva6h_{INDEX}.png",
    mapPrecipitationStartIndex: 1,
    mapPrecipitationEndIndex: 28,

    mapTemperatureUrlTemplate: "/riak/modelos_site/temperatura_2m_{INDEX}.png",
    mapTemperatureStartIndex: 1,
    mapTemperatureEndIndex: 28,

    mapWindUrlTemplate: "/riak/modelos_site/rajada_lc_{INDEX}.png",
    mapWindStartIndex: 1,
    mapWindEndIndex: 28,
  }),
  watch: {
    mapItem(value) {
      if (value) {
        this.play = false;
        this.clearAnimationInterval();
        this.currentIndex = 0;
        this.verifyMapItem();
      }
    },
  },
  mounted() {
    this.verifyMapItem();
  },
  computed: {
    startMap() {
      return 0;
    },
    currentMap() {
      return this.maps[this.currentIndex % this.maps.length];
    },
    endMap() {
      return this.maps.length - 1;
    },
    mapRadar() {
      let images = [];
      for (let i = this.mapRadarStartIndex; i >= this.mapRadarEndIndex; i--) {
          images.push(this.mapRadarUrlTemplate.replace("{INDEX}", i));
        }
      return images;
    },
    mapPrecipitation() {
      let images = [];
      for (let i = this.mapPrecipitationStartIndex; i <= this.mapPrecipitationEndIndex; i++) {
          images.push(this.mapPrecipitationUrlTemplate.replace("{INDEX}", i));
        }
      return images;
    },
    mapTemperature() {
      let images = [];
      for (let i = this.mapTemperatureStartIndex; i <= this.mapTemperatureEndIndex; i++) {
          images.push(this.mapTemperatureUrlTemplate.replace("{INDEX}", i));
        }
      return images;
    },
    mapWind() {
      let images = [];
      for (let i = this.mapWindStartIndex; i <= this.mapWindEndIndex; i++) {
          images.push(this.mapWindUrlTemplate.replace("{INDEX}", i));
        }
      return images;
    },
  },

  methods: {
    verifyMapItem() {
      if (this.mapItem.text === "Radar Meterológico") {
        this.maps = [...this.mapRadar];

        // last index is most up to date
        this.currentIndex = this.mapRadarStartIndex - this.mapRadarEndIndex;
      } else if (this.mapItem.text === "Chuva") {
        this.maps = [...this.mapPrecipitation];
      } else if (this.mapItem.text === "Temperatura") {
        this.maps = [...this.mapTemperature];
      } else if (this.mapItem.text === "Vento") {
        this.maps = [...this.mapWind];
      }
    },
    startSlide() {
      this.play = !this.play;
      if (this.play) {
        this.timer = setInterval(() => {
          if (this.currentIndex == this.endMap) {
            this.currentIndex = this.startMap;
          } else {
            this.currentIndex += 1;
          }
        }, 2800);
      } else {
        this.clearAnimationInterval();
      }
    },
    clearAnimationInterval() {
      clearInterval(this.timer);
      this.play = false;
    },
  },
};
</script>

<style scoped>

.animation-time-map-slider {
  width: 999px;
  height: 8px;
  left: 0px;
  top: 4px;
  border-radius: 4px 0px 0px 4px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
